/*
 * @Description:
 * @Version: 2.0
 * @Autor: qinhao.chang
 * @Date: 2022-04-14 15:43:06
 * @LastEditors: qinhao.chang
 * @LastEditTime: 2022-07-06 18:16:43
 */
// import Banner from "./banner.png";
import Foryou from "./Foryou.png";
import Life from "./life.png";
import Photography from "./Photography.png";
import Music from "./Music.png";
import Tech from "./Tech.png";
import Sport from "./Sport.png";
import Games from "./Games.png";
import Pause from "./pause.png";
import Logo from "./logo.png";
import Initial from "./initial.png";
import Topic from "./topic.png";
import QRcode from "./qrcode.png";
import Code from "./code.png";
import News from "./news.png";
import Entertainment from "./entertainment.png";

import Video from "./video.png";
import Feedback from "./feedback.png";
import VideoIcon from "./videoicon.png"
import FeedbackIcon from "./feedbackicon.png"
import postIcon from "./posticon.png"



// import Logo from "./LOGO.svg";

export {
  // Banner,
  Foryou,
  Life,
  VideoIcon,
  FeedbackIcon,
  postIcon,
  Photography,
  Music,
  Tech,
  Video,
  Feedback,
  Sport,
  Games,
  Pause,
  Logo,
  Initial,
  Topic,
  QRcode,
  Code,
  News,
  Entertainment,
  // Logo
};
